/* eslint react/jsx-filename-extension: 0 */
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { render } from "react-dom";
import Routes from "./routes";

render(
  <BrowserRouter>
    <Routes />
  </BrowserRouter>,
  document.getElementById("root")
);
